import { useEffect, useRef, useState } from 'react';
import { initializeLiff } from './utils/liff';
import LoadingPage from './pages/LoadingPage';
import ErrorPage from './pages/ErrorPage';

const VENDOR_OAUTH_URL = 'https://xapix.skyknow.cc/api/oauth/line/login?userType=vendor';

function App() {
  const redirectStarted = useRef(false);
  const [liffState, setLiffState] = useState<{
    isReady: boolean;
    isLoggedIn: boolean;
    error: Error | null;
  }>({
    isReady: false,
    isLoggedIn: false,
    error: null,
  });

  useEffect(() => {
    const init = async () => {
      try {
        const result = await initializeLiff();

        if (!result.isLoggedIn) {
          // 如果未登入，導向登入
          console.log('User not logged in, redirecting to login...');
          // liff.login() 會在 initializeLiff 中呼叫
          return;
        }

        // LIFF identity alone is not a vendor session. Re-enter the server
        // verified OAuth flow so oauth-success can issue vendor_token before
        // the dashboard loads. This also works after a stale token expires.
        if (!redirectStarted.current) {
          redirectStarted.current = true;
          console.log('LIFF login successful, handing off to verified LINE OAuth...');
          window.location.replace(VENDOR_OAUTH_URL);
        }

        setLiffState({
          isReady: true,
          isLoggedIn: result.isLoggedIn,
          error: null,
        });
      } catch (error) {
        console.error('LIFF initialization failed:', error);
        setLiffState({
          isReady: true,
          isLoggedIn: false,
          error: error as Error,
        });
      }
    };

    init();
  }, []);

  // 載入中
  if (!liffState.isReady) {
    return <LoadingPage />;
  }

  // 發生錯誤
  if (liffState.error) {
    return <ErrorPage error={liffState.error} />;
  }

  // 未登入（理論上不會到這裡，因為會在 initializeLiff 中處理）
  if (!liffState.isLoggedIn) {
    return <LoadingPage message="正在登入..." />;
  }

  // 登入成功，正在把 LINE 身分交給後端換發業者工作階段
  return <LoadingPage message="正在恢復餐車業者登入..." />;
}

export default App;
